export default "__VITE_ASSET__BVBz2gS1__"